import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { Row, Col, Label, Input, Form, FormGroup, Button, Card } from "reactstrap";
import { useForm } from "react-hook-form";
import Dropzone from 'react-dropzone-uploader';
import axios from 'axios';
import { toast } from "react-toastify";

import RequiredIndicator from '../../../../partial/RequiredIndicator';
import { useDispatch, useSelector } from "react-redux";
import { mykyc } from '../../../../../redux/kyc/action';
import handleupload from '../../../../../utilities/handleUpload';
import validateFile from '../../../../../utilities/validateFile';
import PDFViewer from '../../../../../utilities/PDFViewer';
import { Edit, InfoOutlined } from '@mui/icons-material';
import FileUploadComponent from '../../../../common/FileUpload';
import KycEditNote from '../../kyc_note/KycEditNote';
import KycViewNote from '../../kyc_note/KycViewNote';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import specialCharacterConstrains from '../../../../../utilities/specialCharacterConstrains';

const BankDetails = (props) => {
  const { activeStep, setActiveStep, setStep4Valid, dealerKycData, is_kyc_submitted, is_kyc_active, setIsUpdated, isGstVerified, re_kyc } = props;
  const showReadOnlyBank = (is_kyc_submitted || is_kyc_active);

  const { register, getValues, setValue, handleSubmit, errors, setError, trigger } = useForm();
  const [loading, setLoading] = useState(false);
  const [cancelChequeUrl, setCancelChequeUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const kycData = useSelector((content) => content.Kyc);
  const dispatch = useDispatch();
  const [fileUploadFlag, setFileUploadFlag] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const submitForm = async (data) => {
    setLoading(true);
    data.cancelled_cheque_number = 'NA';
    dispatch(mykyc({ ...kycData, bankDetails: { ...kycData.bankDetails, ...data }, txnid: Date.now() }));
    setIsEditing(false);
    setIsUpdated(true)
    setTimeout(() => {
      setIsUpdated(false)
    }, 2000);
    // Reset loading to avoid UI stuck state
    setLoading(false);
    // Expected Bank index: PAN (0) + optional GST (1) + TAN (1) + MSME (1)
    const expectedIndex = 3 + (isGstVerified ? 1 : 0);
    if (activeStep === expectedIndex) {
      setStep4Valid(true);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

  };
  // called every time a file's `status` change

  useEffect(() => {

    async function checkDetails() {
      const storedData = kycData.bankDetails;
      Object.keys(storedData).forEach(async (fieldName) => {
        await setValue(fieldName, storedData[fieldName]);
      });
      setCancelChequeUrl(getValues()["cancelled_cheque_image"])
    }

    checkDetails()

  }, []);

  const handleBack = () => {
    if (is_kyc_submitted) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      const rhfdata = getValues()
      dispatch(mykyc({ ...kycData, bankDetails: { ...kycData.bankDetails, ...rhfdata }, txnid: Date.now() }));
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const onSubmitForKycSubmitComplete = () => {
    const expectedIndex = 3 + ((isGstVerified || re_kyc) ? 1 : 0);
    if (activeStep === expectedIndex) {
      setStep4Valid(true);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  }

  const verifyIFSC = async (ifsc) => {
  try {
    console.log("veroify IFSC called", ifsc);
    const { data } = await axios.get(
      `https://ifsc.razorpay.com/${ifsc}`
    );

    setValue("bank_name", data.BANK);
    console.log("bank_name", data.BANK)
    toast.success("IFSC Verified");
  } catch (err) {
    console.log('error in verifyIFSC', err)
    // setError("ifsc_code", {
    //   type: "manual",
    //   message: "Invalid IFSC Code"
    // });
  }
};
  console.log("isEditing", isEditing);

  return (

    <Fragment>

      <Row>

        <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
          <div className="project-box">
            {is_kyc_active && !re_kyc ? (<span className={`badge badge-success`}>{"Verified"}</span>) : ''}


            <div className='mt-3'>
              {showReadOnlyBank  ? (
                <>
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Bank Account Number"}</Label>
                        <Input
                          className="form-control"
                          name="bank_account_number"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_account_number}
                          readOnly
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>{"Bank Account Name"}</Label>
                        <Input
                          className="form-control"
                          name="bank_account_name"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_account_name}
                          readOnly
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>{"IFSC Code"}</Label>
                        <Input
                          className="form-control"
                          name="ifsc_code"
                          onBlur={(e) => verifyIFSC(e.target.value.toUpperCase())}
                          type="text"
                          defaultValue={kycData.bankDetails?.ifsc_code}
                          readOnly
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Bank Name"}</Label>
                        <Input
                          className="form-control"
                          name="bank_name"
                          type="text"
                          defaultValue={kycData.bankDetails?.bank_name}
                          readOnly
                        />
                      </FormGroup>
                      <KycViewNote />
                    </Col>

                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className="text-center">
                        <Label> Cancelled Cheque</Label>
                        <FileUploadComponent name="cancelled_cheque_image"
                          fileUploadFlag={false}
                          data={kycData?.bankDetails?.cancelled_cheque_image}
                          viewOnly={true}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      {/* {(getFromLocalStorage("ROLE")?.key === "DEALERSHIP_MANAGER" ||
                        getFromLocalStorage("ROLE")?.key === "CONSOLIDATOR") && (
                          <Button
                            type="button"
                            color="warning"
                            className="me-2"
                            onClick={() => {
                              setValue(
                                "bank_account_number",
                                kycData.bankDetails?.bank_account_number
                              );
                              setValue(
                                "bank_account_name",
                                kycData.bankDetails?.bank_account_name
                              );
                              setValue(
                                "ifsc_code",
                                kycData.bankDetails?.ifsc_code
                              );
                              setValue(
                                "bank_name",
                                kycData.bankDetails?.bank_name
                              );

                              setIsEditing(true);
                            }}
                          >
                            Edit
                          </Button>
                        )} */}
                      <Button type="submit" color="info" onClick={onSubmitForKycSubmitComplete}>
                        Next
                      </Button>
                    </Col>
                  </Row>

                </>
              ) : (getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" || getFromLocalStorage("ROLE")?.key == "CONSOLIDATOR" || isEditing) && (
                <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                  <Row>
                    <Col xl="6" md="6">
                      <FormGroup>
                        <Label>{"Bank Account Number"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_account_number"
                          type="text"
                          innerRef={register(
                            specialCharacterConstrains(true, "Bank Account Number is required", {
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "Bank Account Number must contain only digits",
                              },
                              minLength: {
                                value: 9,
                                message: "Bank Account Number must be at least 9 digits",
                              },
                              maxLength: {
                                value: 18,
                                message: "Bank Account Number must not exceed 18 digits",
                              },
                            })
                          )}
                          defaultValue={getValues()["bank_account_number"] || kycData.bankDetails?.bank_account_number}
                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_account_number?.message}
                        </span>
                      </FormGroup>

                      <FormGroup>
                        <Label>{"Bank Account Name"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_account_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Bank Account Name is required"))}
                          defaultValue={getValues()["bank_account_name"] || kycData.bankDetails?.bank_account_name}
                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_account_name?.message}
                        </span>
                      </FormGroup>

                      <FormGroup>
                        <Label>{"IFSC Code"}</Label> <RequiredIndicator />
                        <Input
                            className="form-control"
                            name="ifsc_code"
                            type="text"
                            innerRef={register(specialCharacterConstrains(true, "IFSC Code is required", ))}
                            // innerRef={register({
                            //   required: "IFSC Code is required",
                            //   pattern: {
                            //     value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                            //     message: "Please enter a valid IFSC Code"
                            //   }
                            // })}
                            defaultValue={getValues()["ifsc_code"] || kycData.bankDetails?.ifsc_code}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              setValue("ifsc_code", value);
                              if (value.length === 11) {
                                verifyIFSC(value);
                              }
                            }}
                          />
                        <span style={{ color: "red" }}>
                          {errors.ifsc_code?.message}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>{"Bank Name"}</Label> <RequiredIndicator />
                        <Input
                          className="form-control"
                          name="bank_name"
                          type="text"
                          innerRef={register(specialCharacterConstrains(true, "Bank Name is required"))}
                          defaultValue={getValues()["bank_name"] || kycData.bankDetails?.bank_name}
                        />
                        <span style={{ color: "red" }}>
                          {errors.bank_name?.message}
                        </span>
                      </FormGroup>
                      <KycEditNote />
                    </Col>

                    <Col xl="6" md="6" className="d-flex justify-content-center">
                      <FormGroup className='text-center'>
                        <Label>{"Upload cancelled cheque document"}</Label> <RequiredIndicator />

                        <FileUploadComponent
                          register={register}
                          name="cancelled_cheque_image"
                          setValue={setValue}
                          trigger={trigger}
                          getValues={getValues}
                          data={cancelChequeUrl}
                          add={getValues()["cancelled_cheque_image"]?.length > 0 ? false : true}
                          pdfImageOnly={true}
                        />
                        <span style={{ color: "red" }}>
                          {errors.cancelled_cheque_image && "Cancelled Cheque Document is Required"}
                        </span>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="justify-content-between">
                    <Col md="auto">
                      {activeStep !== 0 && (
                        <Button
                          color="info"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                        >
                          &lt;&lt; Back
                        </Button>
                      )}
                    </Col>
                    <Col md="auto">
                      {isEditing && (
                        <Button
                          type="button"
                          color="secondary"
                          className="me-2"
                            onClick={() => {
                              setValue("bank_account_number", kycData.bankDetails?.bank_account_number);
                              setValue("bank_account_name", kycData.bankDetails?.bank_account_name);
                              setValue("ifsc_code", kycData.bankDetails?.ifsc_code);
                              setValue("bank_name", kycData.bankDetails?.bank_name);
                              setIsEditing(false);
                            }}
                          >
                            Cancel
                        </Button>
                      )}

                      <Button type="submit" color="info">
                        {loading ? "Loading..." : "Save"} <span>{">>"}</span>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </div>

          </div>
        </Col>

      </Row>
    </Fragment>
  )
};

export default BankDetails;
